/* eslint-disable no-param-reassign */

import api from '@/services/api/task/task'
import bus from '@/bus'
import Vue from 'vue'
export default {
  state: {
    taskModeCheck: {
      icon: 'iconicon_tabulation',
      components: 'ListView',
      key: 2,
      text: '列表'
    },
    iconList: [
      {
        icon: 'iconicon_tabulation',
        components: 'ListView',
        key: 2,
        text: '列表'
      },
      {
        icon: 'iconicon_gantt_chart_chart',
        components: 'Gantt',
        key: 3,
        text: '甘特图'
      }
    ],
    queryMsg: {
      keyword: '', // 搜索
      my_execution: false, // 仅查看我执行的
      status_filter: 'relatedToMeUndoneTasksIndex', // 任务状态  -完成  -未完成
      sort_rule: 'due_date_sort', // 任务排序
      project_id: ''
    }
  },
  mutations: {
    set_keyword: (state, data) => {
      state.queryMsg.keyword = data
    },
    set_my_execution: (state, data) => {
      state.queryMsg.my_execution = data
    },
    set_status_filter: (state, data) => {
      state.queryMsg.status_filter = data
    },
    set_sort_filter: (state, data) => {
      state.queryMsg.sort_rule = data
    },
    set_project_id: (state, data) => {
      state.queryMsg.project_id = data
    },
    set_taskModeCheck: (state, data) => {
      state.taskModeCheck = state.iconList[data]
    },
    clear_queryMsg: (state, data) => {
      state.taskModeCheck = state.iconList[0]
      state.queryMsg = {
        keyword: '', // 搜索
        my_execution: false, // 仅查看我执行的
        status_filter: 'relatedToMeUndoneTasksIndex', // 任务状态  -完成  -未完成
        sort_rule: 'due_date_sort', // 任务排序
        project_id: ''
      }
    }
  },
  getters: {},
  actions: {}
}
